function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 17 20"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.96.388C4.145.152 4.434 0 4.762 0a1.013 1.013 0 01.758.34l3.633 4.035c.37.411.336 1.046-.082 1.422a1.01 1.01 0 01-1.423-.067L5.774 3.649v7.349c0 .553-.45 1.002-1.012 1.002-.56 0-1.013-.456-1.013-1.002v-7.35L1.875 5.73a1.01 1.01 0 01-1.423.067A1.005 1.005 0 01.37 4.375L3.96.388z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.55 19.612a1.012 1.012 0 01-.8.388 1.013 1.013 0 01-.76-.34l-3.632-4.035a1.005 1.005 0 01.082-1.422 1.01 1.01 0 011.423.067l1.874 2.081V9.002c0-.553.449-1.002 1.012-1.002.56 0 1.013.456 1.013 1.002v7.35l1.873-2.082a1.01 1.01 0 011.424-.067c.418.376.452 1.01.081 1.422l-3.59 3.987z"
})));